import type { WorkspaceOperationInOut } from '@festina/configuration-general-types/configuration'
import { ConfigurationRepositoryWorkspacesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryWorkspacesService'
import { assertNotEmpty, type ConfigurableServer } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

type AddWorkspaceOperationsInputArguments = {
  server: ConfigurableServer
  name: string
  operation: WorkspaceOperationInOut
}

export const useAddOrUpdateWorkspaceOperation = () =>
  useMutation({
    mutationFn: async ({
      name,
      server,
      operation: operationInOut,
    }: AddWorkspaceOperationsInputArguments) => {
      const operationKey =
        operationInOut.operation?.operationKey ?? crypto.randomUUID()

      assertNotEmpty(operationInOut.operation)

      await ConfigurationRepositoryWorkspacesService.workspaceServicePutPutWorkspaceOperation(
        {
          workspaceName: name,
          componentName: server.toLocaleLowerCase(),
          requestBody: operationInOut,
          operationKey,
        },
      )

      return operationInOut
    },
  })
